export default "__VITE_PUBLIC_ASSET__2c722436__"